import braces from './braces';
import aligners from './aligners';
import frc from './frc';
import zirconia from './zirconia';
import veneers from './veneers';

export const TREATMENTS = [braces, aligners, frc, zirconia, veneers];

export const getTreatment = (slug) => TREATMENTS.find((t) => t.slug === slug);
